import styled from '@emotion/styled';

import { Button } from 'components/buttons';

export const Container = styled.div((_) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  paddingBottom: 5,
}));

export const ActionBar = styled.div((_) => ({
  display: 'flex',
  gap: 8,
}));

export const Balance = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 5,
  fontSize: 12,
  fontWeight: 500,
  color: theme.colors.primary,
  padding: '0 10px',
  span: {
    display: 'flex',
    gap: 4,
    alignItems: 'center',
    color: theme.colors.inactive,
  },
  path: {
    fill: theme.colors.inactive,
  },
}));

export const TablePlaceholder = styled.div((_) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: 20,
  fontSize: 12,
}));

export const ErrorText = styled.div(({ theme }) => ({
  color: theme.colors.error.main,
}));

export const TopUpButton = styled(Button)(() => ({
  marginLeft: 'auto',
  span: {
    gap: 5,
  },
}));
